// Base de villes reprise de la v1 (641 villes, 177 fuseaux) : noms français, alias anglais,
// pays pour trancher les homonymes. Format : fuseau IANA → [pays, "Nom/Alias/Alias", …].
// Le premier nom de chaque entrée est le libellé affiché ; les suivants sont des alias de recherche.
import { normalize } from './time';

export const PLACES: Record<string, string[]> = {
'Europe/Paris':['France','Paris','Lyon','Marseille','Toulouse','Nice','Nantes','Montpellier','Strasbourg','Bordeaux','Lille','Rennes','Reims','Toulon','Saint-Étienne','Le Havre','Grenoble','Dijon','Angers','Nîmes','Clermont-Ferrand','Aix-en-Provence','Brest','Tours','Amiens','Limoges','Annecy','Perpignan','Metz','Besançon','Orléans','Rouen','Mulhouse','Caen','Nancy','Avignon','La Rochelle','Biarritz','Bayonne','Pau','Chambéry','Valence','Poitiers','Le Mans','Troyes','Lorient','Vannes','Quimper','Colmar','Monaco'],
'Europe/London':['Royaume-Uni','Londres/London','Manchester','Birmingham','Édimbourg/Edinburgh','Glasgow','Liverpool','Bristol','Leeds','Sheffield','Cardiff','Belfast','Newcastle','Oxford','Cambridge','Brighton'],
'Europe/Dublin':['Irlande','Dublin','Cork','Galway','Limerick'],
'Europe/Brussels':['Belgique','Bruxelles/Brussels','Anvers/Antwerpen','Gand/Gent','Liège','Charleroi','Bruges/Brugge','Louvain/Leuven','Namur','Mons'],
'Europe/Amsterdam':['Pays-Bas','Amsterdam','Rotterdam','La Haye/Den Haag/The Hague','Utrecht','Eindhoven','Groningue/Groningen','Maastricht'],
'Europe/Luxembourg':['Luxembourg','Luxembourg'],
'Europe/Zurich':['Suisse','Genève/Geneva','Zurich/Zürich','Bâle/Basel','Berne/Bern','Lausanne','Lugano','Winterthour/Winterthur','Saint-Gall/St. Gallen','Sion','Neuchâtel','Fribourg','Zermatt','Davos'],
'Europe/Berlin':['Allemagne','Berlin','Munich/München','Hambourg/Hamburg','Cologne/Köln','Francfort/Frankfurt','Stuttgart','Düsseldorf','Dortmund','Essen','Leipzig','Brême/Bremen','Dresde/Dresden','Hanovre/Hannover','Nuremberg/Nürnberg','Bonn','Mannheim','Karlsruhe','Fribourg-en-Brisgau/Freiburg','Aix-la-Chapelle/Aachen'],
'Europe/Vienna':['Autriche','Vienne/Wien/Vienna','Graz','Linz','Salzbourg/Salzburg','Innsbruck','Klagenfurt'],
'Europe/Rome':['Italie','Rome/Roma','Milan/Milano','Naples/Napoli','Turin/Torino','Florence/Firenze','Bologne/Bologna','Venise/Venezia','Gênes/Genova','Palerme/Palermo','Vérone/Verona','Bari','Catane/Catania','Trieste','Padoue/Padova'],
'Europe/Madrid':['Espagne','Madrid','Barcelone/Barcelona','Valence/València/Valencia','Séville/Sevilla','Saragosse/Zaragoza','Malaga/Málaga','Bilbao','Murcie/Murcia','Palma','Alicante','Cordoue/Córdoba','Valladolid','Vigo','Grenade/Granada','Saint-Sébastien/San Sebastián'],
'Atlantic/Canary':['Îles Canaries','Las Palmas','Tenerife/Santa Cruz de Tenerife','Fuerteventura','Lanzarote'],
'Europe/Lisbon':['Portugal','Lisbonne/Lisboa/Lisbon','Porto','Braga','Coimbra','Faro','Funchal/Madère/Madeira'],
'Atlantic/Azores':['Açores','Ponta Delgada/Açores/Azores'],
'Europe/Andorra':['Andorre','Andorre-la-Vieille/Andorra la Vella'],
'Europe/Malta':['Malte','La Valette/Valletta'],
'Europe/Zagreb':['Croatie','Zagreb','Split','Dubrovnik','Rijeka'],
'Europe/Ljubljana':['Slovénie','Ljubljana','Maribor'],
'Europe/Belgrade':['Serbie','Belgrade/Beograd','Novi Sad'],
'Europe/Sarajevo':['Bosnie-Herzégovine','Sarajevo','Banja Luka'],
'Europe/Tirane':['Albanie','Tirana/Tirane'],
'Europe/Skopje':['Macédoine du Nord','Skopje'],
'Europe/Prague':['Tchéquie','Prague/Praha','Brno','Ostrava'],
'Europe/Bratislava':['Slovaquie','Bratislava','Košice'],
'Europe/Budapest':['Hongrie','Budapest','Debrecen','Szeged'],
'Europe/Warsaw':['Pologne','Varsovie/Warszawa/Warsaw','Cracovie/Kraków/Krakow','Łódź/Lodz','Wrocław/Wroclaw','Poznań/Poznan','Gdańsk/Gdansk','Katowice'],
'Europe/Bucharest':['Roumanie','Bucarest/București/Bucharest','Cluj-Napoca','Timișoara','Iași'],
'Europe/Sofia':['Bulgarie','Sofia','Plovdiv','Varna'],
'Europe/Athens':['Grèce','Athènes/Athina/Athens','Thessalonique/Thessaloniki','Patras','Héraklion/Heraklion','Rhodes','Santorin/Santorini'],
'Europe/Istanbul':['Turquie','Istanbul','Ankara','Izmir','Antalya','Bursa','Adana'],
'Europe/Nicosia':['Chypre','Nicosie/Nicosia','Limassol','Larnaca'],
'Europe/Stockholm':['Suède','Stockholm','Göteborg/Gothenburg','Malmö','Uppsala'],
'Europe/Oslo':['Norvège','Oslo','Bergen','Trondheim','Stavanger','Tromsø'],
'Europe/Copenhagen':['Danemark','Copenhague/København/Copenhagen','Aarhus','Odense','Aalborg'],
'Europe/Helsinki':['Finlande','Helsinki','Espoo','Tampere','Turku','Oulu'],
'Atlantic/Reykjavik':['Islande','Reykjavik/Reykjavík'],
'Europe/Riga':['Lettonie','Riga'],
'Europe/Vilnius':['Lituanie','Vilnius','Kaunas'],
'Europe/Tallinn':['Estonie','Tallinn','Tartu'],
'Europe/Kyiv':['Ukraine','Kiev/Kyiv','Kharkiv','Odessa/Odesa','Lviv','Dnipro'],
'Europe/Minsk':['Biélorussie','Minsk'],
'Europe/Chisinau':['Moldavie','Chișinău/Chisinau'],
'Europe/Moscow':['Russie','Moscou/Moskva/Moscow','Saint-Pétersbourg/Sankt-Peterburg/St Petersburg','Nijni Novgorod/Nizhny Novgorod','Kazan','Rostov-sur-le-Don/Rostov','Sotchi/Sochi','Volgograd'],
'Europe/Kaliningrad':['Russie','Kaliningrad'],
'Asia/Yekaterinburg':['Russie','Ekaterinbourg/Yekaterinburg','Tcheliabinsk/Chelyabinsk','Oufa/Ufa','Perm'],
'Asia/Novosibirsk':['Russie','Novossibirsk/Novosibirsk','Omsk'],
'Asia/Krasnoyarsk':['Russie','Krasnoïarsk/Krasnoyarsk'],
'Asia/Irkutsk':['Russie','Irkoutsk/Irkutsk'],
'Asia/Vladivostok':['Russie','Vladivostok','Khabarovsk'],
'Africa/Casablanca':['Maroc','Casablanca','Rabat','Marrakech','Tanger','Fès/Fes','Agadir','Meknès','Oujda','Tétouan','Essaouira'],
'Africa/Algiers':['Algérie','Alger/Algiers','Oran','Constantine','Annaba','Blida','Tlemcen','Sétif'],
'Africa/Tunis':['Tunisie','Tunis','Sfax','Sousse','Djerba','Bizerte','Monastir'],
'Africa/Tripoli':['Libye','Tripoli','Benghazi'],
'Africa/Cairo':['Égypte','Le Caire/Cairo','Alexandrie/Alexandria','Gizeh/Giza','Louxor/Luxor','Charm el-Cheikh/Sharm el-Sheikh','Hurghada'],
'Africa/Dakar':['Sénégal','Dakar','Thiès','Saint-Louis','Ziguinchor'],
'Africa/Abidjan':['Côte d’Ivoire','Abidjan','Yamoussoukro','Bouaké','San-Pédro'],
'Africa/Accra':['Ghana','Accra','Kumasi','Tamale'],
'Africa/Lagos':['Nigeria','Lagos','Abuja','Kano','Ibadan','Port Harcourt'],
'Africa/Douala':['Cameroun','Douala','Yaoundé','Bafoussam','Garoua'],
'Africa/Libreville':['Gabon','Libreville','Port-Gentil'],
'Africa/Brazzaville':['Congo','Brazzaville','Pointe-Noire'],
'Africa/Kinshasa':['RD Congo','Kinshasa','Matadi'],
'Africa/Lubumbashi':['RD Congo','Lubumbashi','Goma','Bukavu'],
'Africa/Bamako':['Mali','Bamako','Sikasso','Tombouctou'],
'Africa/Ouagadougou':['Burkina Faso','Ouagadougou','Bobo-Dioulasso'],
'Africa/Niamey':['Niger','Niamey'],
'Africa/Conakry':['Guinée','Conakry'],
'Africa/Lome':['Togo','Lomé'],
'Africa/Porto-Novo':['Bénin','Porto-Novo','Cotonou'],
'Africa/Nouakchott':['Mauritanie','Nouakchott'],
'Africa/Nairobi':['Kenya','Nairobi','Mombasa','Kisumu'],
'Africa/Kampala':['Ouganda','Kampala'],
'Africa/Kigali':['Rwanda','Kigali'],
'Africa/Dar_es_Salaam':['Tanzanie','Dar es Salaam','Dodoma','Zanzibar','Arusha'],
'Africa/Addis_Ababa':['Éthiopie','Addis-Abeba/Addis Ababa'],
'Africa/Khartoum':['Soudan','Khartoum'],
'Africa/Johannesburg':['Afrique du Sud','Johannesburg','Le Cap/Cape Town','Durban','Pretoria','Port Elizabeth','Bloemfontein'],
'Africa/Harare':['Zimbabwe','Harare','Bulawayo'],
'Africa/Lusaka':['Zambie','Lusaka'],
'Africa/Luanda':['Angola','Luanda'],
'Africa/Maputo':['Mozambique','Maputo'],
'Africa/Windhoek':['Namibie','Windhoek'],
'Africa/Gaborone':['Botswana','Gaborone'],
'Indian/Antananarivo':['Madagascar','Antananarivo/Tananarive'],
'Indian/Mauritius':['Maurice','Port-Louis/Île Maurice/Mauritius'],
'Indian/Reunion':['La Réunion','Saint-Denis/La Réunion/Reunion','Saint-Pierre'],
'Indian/Mayotte':['Mayotte','Mamoudzou/Mayotte'],
'Asia/Jerusalem':['Israël','Jérusalem/Jerusalem','Tel-Aviv/Tel Aviv','Haïfa/Haifa'],
'Asia/Beirut':['Liban','Beyrouth/Beirut','Tripoli'],
'Asia/Damascus':['Syrie','Damas/Damascus','Alep/Aleppo'],
'Asia/Amman':['Jordanie','Amman','Aqaba'],
'Asia/Baghdad':['Irak','Bagdad/Baghdad','Bassora/Basra','Erbil'],
'Asia/Riyadh':['Arabie saoudite','Riyad/Riyadh','Djeddah/Jeddah','La Mecque/Mecca','Dammam','Médine/Medina'],
'Asia/Dubai':['Émirats arabes unis','Dubaï/Dubai','Abou Dhabi/Abu Dhabi','Charjah/Sharjah','Al-Aïn/Al Ain'],
'Asia/Qatar':['Qatar','Doha'],
'Asia/Kuwait':['Koweït','Koweït/Kuwait City'],
'Asia/Bahrain':['Bahreïn','Manama'],
'Asia/Muscat':['Oman','Mascate/Muscat','Salalah'],
'Asia/Tehran':['Iran','Téhéran/Tehran','Machhad/Mashhad','Ispahan/Isfahan','Chiraz/Shiraz'],
'Asia/Baku':['Azerbaïdjan','Bakou/Baku'],
'Asia/Tbilisi':['Géorgie','Tbilissi/Tbilisi','Batoumi/Batumi'],
'Asia/Yerevan':['Arménie','Erevan/Yerevan'],
'Asia/Karachi':['Pakistan','Karachi','Lahore','Islamabad','Rawalpindi','Faisalabad','Peshawar'],
'Asia/Kabul':['Afghanistan','Kaboul/Kabul'],
'Asia/Tashkent':['Ouzbékistan','Tachkent/Tashkent','Samarcande/Samarkand'],
'Asia/Almaty':['Kazakhstan','Almaty','Astana/Nur-Sultan'],
'Asia/Kolkata':['Inde','Calcutta/Kolkata','Mumbai/Bombay','New Delhi/Delhi','Bangalore/Bengaluru','Hyderabad','Chennai/Madras','Pune','Ahmedabad','Jaipur','Surat','Goa','Kochi/Cochin','Chandigarh','Noida','Gurgaon/Gurugram'],
'Asia/Colombo':['Sri Lanka','Colombo'],
'Asia/Kathmandu':['Népal','Katmandou/Kathmandu'],
'Asia/Dhaka':['Bangladesh','Dacca/Dhaka','Chittagong'],
'Asia/Yangon':['Birmanie','Rangoun/Yangon'],
'Asia/Bangkok':['Thaïlande','Bangkok','Chiang Mai','Phuket','Pattaya'],
'Asia/Phnom_Penh':['Cambodge','Phnom Penh','Siem Reap'],
'Asia/Vientiane':['Laos','Vientiane'],
'Asia/Ho_Chi_Minh':['Viêt Nam','Hô Chi Minh-Ville/Ho Chi Minh/Saigon','Hanoï/Hanoi','Da Nang','Haiphong'],
'Asia/Kuala_Lumpur':['Malaisie','Kuala Lumpur','Penang','Johor Bahru'],
'Asia/Singapore':['Singapour','Singapour/Singapore'],
'Asia/Jakarta':['Indonésie','Jakarta','Surabaya','Bandung','Medan','Yogyakarta'],
'Asia/Makassar':['Indonésie','Makassar','Bali/Denpasar'],
'Asia/Manila':['Philippines','Manille/Manila','Cebu','Davao','Quezon City'],
'Asia/Shanghai':['Chine','Shanghai/Shanghaï','Pékin/Beijing','Shenzhen','Canton/Guangzhou','Chengdu','Hangzhou','Wuhan','Xi’an/Xian','Chongqing','Tianjin','Nankin/Nanjing','Qingdao','Suzhou','Dalian','Shenyang','Xiamen','Ningbo'],
'Asia/Hong_Kong':['Hong Kong','Hong Kong'],
'Asia/Macau':['Macao','Macao/Macau'],
'Asia/Taipei':['Taïwan','Taipei','Kaohsiung','Taichung'],
'Asia/Seoul':['Corée du Sud','Séoul/Seoul','Busan','Incheon','Daegu'],
'Asia/Tokyo':['Japon','Tokyo','Osaka','Kyoto','Yokohama','Nagoya','Sapporo','Fukuoka','Kobe','Hiroshima','Sendai','Okinawa/Naha'],
'Australia/Sydney':['Australie','Sydney','Melbourne','Canberra','Wollongong'],
'Australia/Brisbane':['Australie','Brisbane','Gold Coast','Cairns','Townsville'],
'Australia/Adelaide':['Australie','Adélaïde/Adelaide'],
'Australia/Perth':['Australie','Perth','Fremantle'],
'Australia/Darwin':['Australie','Darwin'],
'Australia/Hobart':['Australie','Hobart'],
'Pacific/Auckland':['Nouvelle-Zélande','Auckland','Wellington','Christchurch','Queenstown'],
'Pacific/Fiji':['Fidji','Suva'],
'Pacific/Noumea':['Nouvelle-Calédonie','Nouméa/Noumea'],
'Pacific/Tahiti':['Polynésie française','Papeete/Tahiti'],
'Pacific/Honolulu':['Hawaï','Honolulu/Hawaii'],
'Pacific/Guam':['Guam','Hagåtña/Guam'],
'Pacific/Port_Moresby':['Papouasie-Nouvelle-Guinée','Port Moresby'],
'America/New_York':['États-Unis','New York','Washington','Boston','Philadelphie/Philadelphia','Atlanta','Miami','Détroit/Detroit','Charlotte','Orlando','Pittsburgh','Baltimore','Cleveland','Tampa','Raleigh','Cincinnati','Columbus','Indianapolis'],
'America/Chicago':['États-Unis','Chicago','Houston','Dallas','Austin','San Antonio','Nashville','La Nouvelle-Orléans/New Orleans','Minneapolis','Kansas City','Saint-Louis/St Louis','Milwaukee','Memphis','Oklahoma City'],
'America/Denver':['États-Unis','Denver','Salt Lake City','Albuquerque','Boise','Colorado Springs'],
'America/Phoenix':['États-Unis','Phoenix','Tucson','Scottsdale'],
'America/Los_Angeles':['États-Unis','Los Angeles','San Francisco','Seattle','San Diego','San José/San Jose','Portland','Sacramento','Las Vegas','Oakland','Palo Alto','Silicon Valley/Mountain View'],
'America/Anchorage':['États-Unis','Anchorage'],
'America/Toronto':['Canada','Toronto','Montréal/Montreal','Ottawa','Québec/Quebec City','Hamilton'],
'America/Vancouver':['Canada','Vancouver','Victoria','Kelowna'],
'America/Edmonton':['Canada','Edmonton','Calgary','Banff'],
'America/Winnipeg':['Canada','Winnipeg','Regina'],
'America/Halifax':['Canada','Halifax','Moncton'],
'America/St_Johns':['Canada','Saint-Jean de Terre-Neuve/St Johns'],
'America/Mexico_City':['Mexique','Mexico/Mexico City','Guadalajara','Puebla','Monterrey','Querétaro','Oaxaca'],
'America/Cancun':['Mexique','Cancún/Cancun','Playa del Carmen','Tulum'],
'America/Tijuana':['Mexique','Tijuana','Mexicali'],
'America/Guatemala':['Guatemala','Guatemala'],
'America/Costa_Rica':['Costa Rica','San José'],
'America/Panama':['Panama','Panama'],
'America/Havana':['Cuba','La Havane/Havana'],
'America/Santo_Domingo':['République dominicaine','Saint-Domingue/Santo Domingo','Punta Cana'],
'America/Port-au-Prince':['Haïti','Port-au-Prince'],
'America/Jamaica':['Jamaïque','Kingston'],
'America/Martinique':['Martinique','Fort-de-France/Martinique'],
'America/Guadeloupe':['Guadeloupe','Pointe-à-Pitre/Guadeloupe','Basse-Terre'],
'America/Cayenne':['Guyane','Cayenne/Guyane'],
'America/Bogota':['Colombie','Bogotá/Bogota','Medellín/Medellin','Cali','Carthagène/Cartagena'],
'America/Lima':['Pérou','Lima','Cuzco/Cusco','Arequipa'],
'America/Caracas':['Venezuela','Caracas','Maracaibo'],
'America/Guayaquil':['Équateur','Guayaquil','Quito'],
'America/La_Paz':['Bolivie','La Paz','Santa Cruz de la Sierra'],
'America/Asuncion':['Paraguay','Asunción/Asuncion'],
'America/Montevideo':['Uruguay','Montevideo','Punta del Este'],
'America/Santiago':['Chili','Santiago','Valparaíso/Valparaiso'],
'America/Argentina/Buenos_Aires':['Argentine','Buenos Aires','Córdoba','Rosario','Mendoza'],
'America/Sao_Paulo':['Brésil','São Paulo/Sao Paulo','Rio de Janeiro','Brasília/Brasilia','Belo Horizonte','Curitiba','Porto Alegre','Salvador','Florianópolis/Florianopolis','Campinas'],
'America/Recife':['Brésil','Recife','Fortaleza','Natal','Maceió/Maceio'],
'America/Manaus':['Brésil','Manaus','Belém/Belem'],
'UTC':['Temps universel','UTC/GMT/Temps universel']
};

export interface Place {
  tz: string;
  label: string;
  country: string;
  keys: string[];
}

export const ZONE_LABEL: Record<string, string> = {};
export const PLACE_INDEX: Place[] = [];
for (const tz of Object.keys(PLACES)) {
  const entry = PLACES[tz]!;
  for (let i = 1; i < entry.length; i++) {
    const names = entry[i]!.split('/');
    const label = names[0]!;
    if (i === 1) ZONE_LABEL[tz] = label;
    PLACE_INDEX.push({ tz, label, country: entry[0]!, keys: names.map(normalize) });
  }
}

/** Ville principale d’un fuseau (ou dernier segment de l’identifiant IANA). */
export const city = (tz: string): string => ZONE_LABEL[tz] || (tz.split('/').pop() ?? tz).replaceAll('_', ' ');

/** Pays d’un fuseau connu, sinon le continent de l’identifiant IANA. */
export const countryOf = (tz: string): string => PLACES[tz]?.[0] ?? (tz.split('/')[0] ?? '').replaceAll('_', ' ');

let allZones: string[] | null = null;
function zones(): string[] {
  if (!allZones) {
    let z: string[] = [];
    try { z = Intl.supportedValuesOf('timeZone'); } catch { z = []; }
    allZones = [...new Set([...z, ...Object.keys(PLACES), 'UTC'])].sort((a, b) => city(a).localeCompare(city(b), 'fr'));
  }
  return allZones;
}

export const SUGGEST = ['Europe/Paris', 'Europe/London', 'Europe/Brussels', 'Europe/Zurich', 'America/New_York', 'America/Los_Angeles', 'America/Sao_Paulo', 'Africa/Casablanca', 'Asia/Dubai', 'Asia/Kolkata', 'Asia/Shanghai', 'Asia/Tokyo', 'Australia/Sydney'];

/**
 * Recherche libre : français ou anglais, avec ou sans accent, alias (bombay → Mumbai),
 * puis pays, puis identifiants IANA non répertoriés. Champ vide → suggestions.
 */
export function searchZones(q: string, limit = 40): Place[] {
  const n = normalize(q).trim();
  if (!n) return SUGGEST.map((tz) => PLACE_INDEX.find((p) => p.tz === tz)).filter((p): p is Place => !!p);
  const hit: Array<[number, Place]> = [];
  for (const p of PLACE_INDEX) {
    let r = -1;
    for (const k of p.keys) {
      const i = k.indexOf(n);
      if (i === 0) { r = 0; break; }
      if (i > 0 && r < 0) r = 1;
    }
    if (r < 0 && normalize(p.country).startsWith(n)) r = 2;
    if (r >= 0) hit.push([r, p]);
  }
  for (const z of zones()) {
    if (ZONE_LABEL[z]) continue;
    const lab = city(z);
    if (normalize(lab + ' ' + z).includes(n)) hit.push([3, { tz: z, label: lab, country: countryOf(z), keys: [normalize(lab)] }]);
  }
  hit.sort((a, b) => a[0] - b[0] || a[1].label.localeCompare(b[1].label, 'fr'));
  return hit.slice(0, limit).map((h) => h[1]);
}

/** Retrouve l’entrée exacte (fuseau + libellé), pour réafficher un contact existant. */
export function findPlace(tz: string, label: string): Place | undefined {
  return PLACE_INDEX.find((p) => p.tz === tz && p.label === label);
}
